import { IApiEntitySmpAgTag } from "@smp/api";
import { UiBox } from "@smp/ui";

import { SelectedTagChip } from "../../../../components";
import { useContextPolotnoTemplates } from "../../../../context";
import { useStyles } from "./selected_tags.css";

export const SelectedTags = () => {
  const classes = useStyles();

  const {
    actions: { updateSelectedTags },
    state: { selectedTags },
  } = useContextPolotnoTemplates();

  const handleClick = (tag: IApiEntitySmpAgTag) => {
    if (tag.parent) {
      updateSelectedTags(tag.parent, undefined);
    }
  };

  return (
    <UiBox className={classes.wrapper}>
      {selectedTags.map((slug) => (
        <SelectedTagChip slug={slug} key={slug} onClick={handleClick} />
      ))}
    </UiBox>
  );
};
